import type { Doc } from "building-types/doc";
import type { OptionTemplateHandle } from "building-types/handles/docEntityHandleTypes";
import type {
  DocOptionSetOverrides,
  OptionSetOverride,
  OptionSetOverrides,
} from "building-types/options/optionTemplateTypes";
import type { RWTable, Table } from "common/data/table";
import objectFilter from "common/utils/objectFilter";
import objectIsEmpty from "common/utils/objectIsEmpty";
import { docEntityGetSortedChildrenFromTable } from "../entity/docEntityGetChildrenFromTable";

/**
 * Convert a DocOptionTemplate (useful in studio) into a simpler more universal OptionTemplate
 * which is just a table of OptionSetOverrides
 */

export function docOptionSetOverridesNormalize(
  table: Table<DocOptionSetOverrides>,
  optionTemplateId: string,
  optionSetId?: string,
) {
  const overrides: OptionSetOverrides = {};

  if (table && optionTemplateId) {
    for (const x of docEntityGetSortedChildrenFromTable(table, optionTemplateId)) {
      if (!optionSetId || optionSetId === x.optionSetId) {
        const optionSetOverride: OptionSetOverride = {
          name: x.overrideName,
          options: x.options,
          disabled: x.disabled,
          category: x.category,
          defaultValue: x.defaultValue,
          salesCategory: x.salesCategory,
          description: x.description,
          disconnectCondition: x.disconnectCondition,
          disconnectConditionOptions: x.disconnectConditionOptions,
        };

        const filtered = objectFilter(optionSetOverride, (v) => v !== undefined);
        if (!objectIsEmpty(filtered)) {
          overrides[x.optionSetId] = filtered;
        }
      }
    }
  }

  return overrides;
}

export function docGetOptionTemplateOverridesByOptionSetId(
  doc: Doc,
  { id: optionTemplateId }: OptionTemplateHandle,
): Table<DocOptionSetOverrides> {
  const output: RWTable<DocOptionSetOverrides> = {};
  if (doc) {
    docEntityGetSortedChildrenFromTable(doc.optionSetOverrides, optionTemplateId).forEach(
      (x) => (output[x.optionSetId] = x),
    );
  }
  return output;
}
